module.exports = __webpack_public_path__ + "img/info-circle.84cc48c3.png";